import React, { useState } from 'react'
import SingelTodo from './SingelTodo'

export default function TodosGroup(props) {


    return (
        <div className="container p-15 mt-6 m-auto">
            <h1 className="text-6xl font-bold text-center m-5">{props.TodoData.length === 0 ? "No Todos To Display - 0" : 'Your Todo List - ' + props.TodoData.length}</h1>

            {
                props.TodoData.map((e) => { return (<SingelTodo sno={e.sno} title={e.title} theme={props.theme} description={e.description} handeldelete={props.handeldelete} />) })

            }


        </div>
    )
}
